import { ICourse } from '@/types/course'
import classNames from 'classnames'

type CourseMotivationProps = {
  courseInfo: Pick<
    ICourse,
    'courseMotivation' | 'categories' | '_id' | 'educationProvider' | 'imageUrl'
  >
} & React.HTMLAttributes<HTMLDivElement>

export function CourseMotivation({
  courseInfo,
  ...props
}: CourseMotivationProps) {
  const { courseMotivation } = courseInfo || {}

  if (!courseMotivation) {
    return null
  }

  const { motivation } = courseMotivation

  return motivation ? (
    <div
      {...props}
      className={classNames('px-4 py-8 pb-12 md:pb-16', props.className)}
    >
      <p
        className={classNames(
          'mx-auto block max-w-prose text-center font-sans text-lg leading-6 text-mydra-black md:text-[34px] md:leading-[117%]'
        )}
      >
        {motivation}
      </p>
    </div>
  ) : null
}
